import { FieldSectorId, WorldDataHelper } from 'Utility/WorldDataHelper';

/**
 * Get the field & sector identifier.
 * TODO: Replace instances of string concatenation to use this method.
 * @param fieldId
 * @param sectorId
 */
export function getFieldSectorId(fieldId: string, sectorId: number): FieldSectorId {
    return `${fieldId}_${sectorId}`;
}

/**
 * Get all field IDs unlocked at the specified level up to the specified world number.
 * @param level
 * @param world
 */
export function getUnlockedFields(level: number, world?: number): FieldSectorId[] {
    const fields: FieldSectorId[] = [];

    WorldDataHelper.getAllFieldsData(world).forEach(field => {
        field.requiredLevel.forEach((requiredLevel, index) => {
            if (level >= requiredLevel) {
                fields.push(getFieldSectorId(field.id, index));
            }
        });
    });

    return fields;
}
